
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ReportingApi from "@/services/reporting-api";
import { mapGetters } from 'vuex';
import MenuChart from "./MenuChart.vue";
import { frLocale, frRanges } from "@/datePickerConfig.js";



/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports Vente",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, MenuChart},

  
  computed:{
     ...mapGetters('menu', ['menuCampaignId', "menuCampaign"]),


    formattedData() {
      if (!this.menuItemStats) return [];

      const data = this.menuItemStats;

      return [
        {
          title: "Articles les plus commandés",
          items: data.mostOrdered.slice(0, 5).map(i => ({
            name: i.itemTitle,
            value: i.totalQuantity,
            turnover: i.turnoverAsStr
          })),
        },

        {
          title: "Articles moins commandés",
          items: data.leastOrdered.slice(0, 5).map(i => ({
            name: i.itemTitle,
            value: i.totalQuantity,
            turnover: i.turnoverAsStr
          })),
        },

        {
          title: "Articles les plus consultés",
          items: data.mostConsulted.slice(0, 5).map(i => ({
            name: i.itemName,
            value: i.totalConsultations,
          })),
        },

        {
          title: "Articles les moins consultés",
          items: data.leastConsulted.slice(0, 5).map(i => ({
            name: i.itemName,
            value: i.totalConsultations,
          })),
        }
      ];
    },

    pagedViewedButRarelyOrdered() {
      const data = this.itemsViewedButRarelyOrdered;
      if (!data) return null;

      const start = (this.salesPerformanceByCategoryPageChart - 1) * this.salesPerformanceByCategoryPageSize;
      const end = start + this.salesPerformanceByCategoryPageSize;

      return {
        label: data.label?.slice(start, end) || [],
        fullName: data.fullName?.slice(start, end) || [],
        consulted: data.consulted?.slice(start, end) || [],
        ordered: data.ordered?.slice(start, end) || [],
        conversionRate: data.conversionRate?.slice(start, end) || []
      };
    }

  },

  data(){

    const now = new Date();
    const currentYear = now.getFullYear();

    return{
      range: {
            startDate: new Date(`${currentYear}-01-01`),
            endDate: now,
          },
      frLocale,
      frRanges,
      menuItemStats:null,
      salesPerformanceBySection:null,
      salesPerformanceByCategoryPageChart: 1,
      salesPerformanceByCategoryPageSize: 10,
      menuChartKey: 0,
      itemsViewedButRarelyOrdered:null,
      averageRevenueByCustomer:null,
      averageRevenueByTable:null,


    }
  },

  watch:{

    menuCampaignId:function(){
      this.showConfigureQRCode = false
      this.initReportingCustomerCompnent()
    },

    range:function(){
      this.initReportingCustomerCompnent()
    }

    },

  created(){
    this._menuItemStatsToken = 0;
    this._viewedButRarelyOrderedToken = 0;
  },

  mounted(){
    this.initReportingCustomerCompnent()
  },

  methods:{

    initReportingCustomerCompnent(){
      this.getMenuItemStats()
      this.getSalesPerformanceBySection()
      this.findViewedButRarelyOrdered()
      this.getAverageRevenueByCustomer()
      this.getAverageRevenueByTable()

    },


    nextPageSalesPerformanceByCategoryPage() {
      const total = this.itemsViewedButRarelyOrdered?.label?.length || 0;
      const totalPages = Math.ceil(total / this.salesPerformanceByCategoryPageSize);

      if (this.salesPerformanceByCategoryPageChart < totalPages) {
        this.salesPerformanceByCategoryPageChart++;
      }
      this.menuChartKey++
    },

    prevPageSalesPerformanceByCategoryPage() {
      if (this.salesPerformanceByCategoryPageChart > 1) {
        this.salesPerformanceByCategoryPageChart--;
      }
      this.menuChartKey++
    },


    // API CALL //

    getAverageRevenueByCustomer(){
      const params = {
        campaignId: this.menuCampaignId == null ? null : this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };

      ReportingApi.getAverageRevenueByCustomer(params).then(
        (result) => {
          if (result) {
            this.averageRevenueByCustomer = result;
          }
        }
      );
    },

    getAverageRevenueByTable(){
      const params = {
        campaignId: this.menuCampaignId == null ? null : this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };

      ReportingApi.getAverageRevenueByTable(params).then(
        (result) => {
          if (result) {
            this.averageRevenueByTable = result;
          }
        }
      );
    },

    getMenuItemStats(){
      const token = ++this._menuItemStatsToken;

      const params = {
        menuCampaignId: this.menuCampaignId == null ? null : this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };

      ReportingApi.getMenuItemStats(params).then(
        (result) => {
          if (result && token === this._menuItemStatsToken) {
            this.menuItemStats = result;
          }
        }
      );
    },

    getSalesPerformanceBySection(){

      const params = {
        menuCampaignId: this.menuCampaignId == null ? null : this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };

      ReportingApi.getSalesPerformanceBySection(params).then(
        (result) => {
          if (result) {
            this.salesPerformanceBySection = result;
          }
        }
      );
    },


    findViewedButRarelyOrdered(){
      const token = ++this._viewedButRarelyOrderedToken;

      const params = {
        menuCampaignId: this.menuCampaignId == null ? null : this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };

      ReportingApi.findViewedButRarelyOrdered(params).then(
        (result) => {
          if (result && token === this._viewedButRarelyOrderedToken) {
            this.itemsViewedButRarelyOrdered = result;
          }
        }
      );
    },







  }
}
</script>

<template>
  <Layout>

    <div class="home-page-80-width">


      <div class="my-4 mx-1">
        <div class="row">
          
          <div class="col-lg-9 col-md-7 col-12 mb-2 mb-md-0">
            <h4 class="global-metric-title">Performance</h4>
            <div style="font-size: 11px;" v-if="menuCampaign && menuCampaign.customerName">
                Client: <a href="#" class="text-primary">{{ menuCampaign.customerName }}</a> | <a href="#" class="text-primary">{{ menuCampaign.menuName }}</a>
            </div>
          </div>

          <div class="col-lg-3 col-md-5 col-12 text-right">
            <v-dateRangePicker
              ref="picker"
              v-model="range"
              :autoApply="true"
              :locale-data="frLocale"
              opens="left"
              :ranges="frRanges"
            />
          </div>

        </div>
      </div>


      <div class="d-flex flex-wrap my-4" style="gap: 10px;">

        <b-card class="text-left global-metric-card p-3 mx-1">
          <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
            Analyse du menu
          </div>

          <b-card
            v-for="(card, index) in formattedData"
            :key="index"
            class="bg-light mb-3 border-0 shadow-sm"
          >
            <div class="d-flex flex-column">

              <!-- Title with Placeholder -->
              <div class="d-flex align-items-center mb-2 flex-wrap">
                <!-- Placeholder -->
                <div
                  class="rounded mr-2"
                  style="width:50px; height:50px; background-color: #E2E8F0;"
                ></div>

                <!-- Title -->
                <div class="font-weight-bold text-dark">
                  {{ card.title }}
                </div>
              </div>

              <!-- Items -->
              <div
                v-for="item in card.items"
                :key="item.name"
                class="d-flex flex-wrap justify-content-between align-items-center mb-1 text-dark"
                style="line-height:1.2; font-size: 12px;"
              >
                <span class="d-flex align-items-center text-truncate" style="margin:0; padding:0; flex:1 1 auto;">
                  <span style="font-size:0.7rem; margin:4px 4px 0 0;">•</span>
                  {{ item.name }}
                </span>

                <span class="font-weight-bold text-dark" style="font-size: 12px; margin:0; padding:0; flex-shrink:0;">
                  {{ item.value }}<span v-if="item.turnover"> | {{ item.turnover }}</span>
                </span>
              </div>

            </div>
          </b-card>


        </b-card>

        <b-card v-if="salesPerformanceBySection && salesPerformanceBySection.sectionTurnover" class="text-left global-metric-card p-3 mx-1">

          <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
            Performance des ventes par catégories
          </div>
          
          <div v-if="salesPerformanceBySection.sectionTurnover.length">
            <div
              v-for="(item, index) in salesPerformanceBySection.sectionTurnover"
              :key="index"
              class="my-4"
            >
              <!-- Header -->
              <div class="d-flex justify-content-between mb-1">
                <span class="font-weight-bold my-1">
                  {{ item.sectionName }}
                </span>

                <span class="text-dark">
                  {{ item.turnoverAsStr}}
                  ({{ item.percentAsStr }})
                </span>
              </div>

              <!-- Progress -->
              <b-progress
                height="8px"
                :value="item.percent"
                max="100"
                class="rounded-pill overflow-hidden"
              ></b-progress>
            </div>
          </div>
          <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
            <p class="text-muted text-center">
              Aucune donnée disponible pour cette période.
            </p>
          </div>



          <hr class="my-5" />

          <div v-if="averageRevenueByTable" class="d-flex flex-wrap justify-md-content-around text-center w-100">
            <div class="flex-fill mb-2 mb-md-0">
              <div class="text-uppercase text-dark" style="font-size: 0.75rem;">
                Ticket Moyen (Table)
              </div>
              <div class="global-metric-title mt-3">
                {{ averageRevenueByTable }}
              </div>
            </div>

            <div v-if="averageRevenueByCustomer" class="flex-fill">
              <div class="text-uppercase text-dark" style="font-size: 0.75rem;">
                Ticket Moyen (Client)
              </div>
              <div class="global-metric-title mt-3">
                {{averageRevenueByCustomer}}
              </div>
            </div>
          </div>

        </b-card>

      </div>

      <div class="my-4">
        <b-card class="text-left global-metric-card p-3 mx-1">

          <div class="row d-flex">
          
            <div class="col-md-6 text-uppercase text-dark font-weight-bold font-size-14 mb-4">
              Taux de conversion des scans
            </div>


            <div class="col-md-6 col-12 d-flex justify-content-end">
              <div>
                <img alt="left" class="mr-2" width="17px" src="@/assets/icons/left-2.svg" style="cursor: pointer;" @click="nextPageSalesPerformanceByCategoryPage"/>
                <span class="text-center mr-2">page {{salesPerformanceByCategoryPageChart}}</span>              
                <img alt="right" width="17px" src="@/assets/icons/right-2.svg" style="cursor: pointer; "  @click="prevPageSalesPerformanceByCategoryPage"
                :style="{ opacity: salesPerformanceByCategoryPageChart === 1 ? 0.5 : 1, pointerEvents: salesPerformanceByCategoryPageChart === 1 ? 'none' : 'auto' }"                    />
              </div>
              <div>
                <select class="custom-select custom-select-sm ml-2"  v-model="salesPerformanceByCategoryPageSize">
                  <option selected value="10">10</option>
                  <option value="30">30</option>
                </select>
              </div>
            </div>
          </div>

          <MenuChart  v-if="itemsViewedButRarelyOrdered" :key="menuChartKey" :stats="pagedViewedButRarelyOrdered" />
        </b-card>
      </div>

      </div>


  </Layout>
</template>









<style>

.period-card{
  background-color: #fff;
  color: #000;
  border-radius: 8px;
  padding: 9px 11px;
  color: #334155;
  font-weight: 500;
  border: 1px solid #ddd;
}

.global-metric-title{
  font-weight: bold;
  font-size: 30px;
  color: #000;
}

.global-metric-card{
  border-radius: 16px;
  border: 1px solid #ddd;
  flex: 1 1 200px;
}

.previewMenuButton{
  background: linear-gradient(135deg, #f4b740, #D4AF37);
  color: #fff;
  letter-spacing: 0.7px;
  line-height: 20px;
  font-weight: bold;
}

</style>